import { IconToggleLeft } from "@tabler/icons-react";
//import { PlusCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppYesNoFieldIcon = (props: Props) => {
  const { className, ...rest } = props;

  return <IconToggleLeft {...rest} className={props.className} />;
};
export default withIconSize(AppYesNoFieldIcon);
